const BILLING_RETURN_CONTEXT_KEY = 'mosaic_billing_return_context_v1';
const BILLING_RETURN_CONTEXT_MAX_AGE_MS = 6 * 60 * 60 * 1000;

export function normalizeBillingReturnContext(raw) {
    if (!raw || typeof raw !== 'object') return null;
    const kind = String(raw.kind || '').trim().toLowerCase();
    const jobId = String(raw.job_id || '').trim();
    if (!jobId) return null;
    const longEdgePx = Number(raw.long_edge_px || 0);
    const normalizedLongEdge = (Number.isFinite(longEdgePx) && longEdgePx > 0) ? Math.round(longEdgePx) : 0;
    if (kind === 'finalize' && normalizedLongEdge <= 0) return null;
    if (kind !== 'finalize' && kind !== 'subscription') return null;
    return {
        kind,
        user_id: String(raw.user_id || '').trim(),
        job_id: jobId,
        long_edge_px: normalizedLongEdge,
        final_run_id: String(raw.final_run_id || '').trim(),
        checkout_intent_id: String(raw.checkout_intent_id || '').trim(),
        checkout_url: String(raw.checkout_url || '').trim(),
        plan_code: String(raw.plan_code || '').trim().toLowerCase(),
        source: String(raw.source || '').trim(),
        saved_at: Number(raw.saved_at || 0),
    };
}

export function saveBillingReturnContext(rawContext, { currentUserId = '' } = {}) {
    const normalized = normalizeBillingReturnContext(rawContext);
    if (!normalized) return;
    const payload = {
        ...normalized,
        user_id: String(currentUserId || '').trim(),
        saved_at: Date.now(),
    };
    try {
        localStorage.setItem(BILLING_RETURN_CONTEXT_KEY, JSON.stringify(payload));
    } catch (_e) {}
}

export function clearBillingReturnContext() {
    try {
        localStorage.removeItem(BILLING_RETURN_CONTEXT_KEY);
    } catch (_e) {}
}

export function getBillingReturnContext({ currentUserId = '' } = {}) {
    let raw = null;
    try {
        raw = localStorage.getItem(BILLING_RETURN_CONTEXT_KEY);
    } catch (_e) {
        return null;
    }
    if (!raw) return null;
    let parsed = null;
    try {
        parsed = JSON.parse(raw);
    } catch (_e) {
        clearBillingReturnContext();
        return null;
    }
    const normalized = normalizeBillingReturnContext(parsed);
    if (!normalized) {
        clearBillingReturnContext();
        return null;
    }
    const ageMs = Math.max(0, Date.now() - Number(normalized.saved_at || 0));
    if (ageMs > BILLING_RETURN_CONTEXT_MAX_AGE_MS) {
        clearBillingReturnContext();
        return null;
    }
    const savedUserId = String(normalized.user_id || '').trim();
    const safeCurrentUserId = String(currentUserId || '').trim();
    if (safeCurrentUserId && savedUserId && safeCurrentUserId !== savedUserId) {
        clearBillingReturnContext();
        return null;
    }
    return normalized;
}
